export enum Wallets {
  MetaMask = 'metaMask',
  WalletConnect = 'walletConnect',
}
